import * as React from 'react';
import Spinner from '@atlaskit/spinner';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { ChunkLoadErrorMessage, LoadingSkeleton } from '@atlassian/help-center-common-component/loading';
import type { LooselyLoadableLoadingComponentProps } from '@atlassian/help-center-common-component/loosely-loadable-wrapper';
import { Container, TopicContainer, HelpObjectContainer, SpinnerWrapper } from '../styled';
import { LoaderContainer, Row } from './styled';

export const EditTopicLoader: React.FC<LooselyLoadableLoadingComponentProps> = (props) => {
    return (
        <>
            {props.error ? (
                <LoaderContainer>
                    <ChunkLoadErrorMessage />
                </LoaderContainer>
            ) : (
                <Container>
                    <TopicContainer>
                        <SpinnerWrapper>
                            <Spinner size={'medium'} />
                        </SpinnerWrapper>
                    </TopicContainer>
                    <HelpObjectContainer>
                        <Row>
                            <LoadingSkeleton height={40} backgroundColor={token('color.skeleton.subtle', colors.N20)} />
                        </Row>
                        <Row>
                            <LoadingSkeleton height={40} backgroundColor={token('color.skeleton.subtle', colors.N20)} />
                        </Row>
                        <Row>
                            <LoadingSkeleton height={40} backgroundColor={token('color.skeleton.subtle', colors.N20)} />
                        </Row>
                    </HelpObjectContainer>
                </Container>
            )}
        </>
    );
};
